import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { CG_BASE_URL } from '@/helpers/constants/app';
import WhiteLabelQuery from '@/plugins/graphql/queries/v2/white-label-content.gql';
let WhiteLabelRedirectMixin = class WhiteLabelRedirectMixin extends Vue {
    get getOrigin() {
        const { origin } = window.location;
        return origin.replace(/^https?:\/\//i, '');
    }
    redirectActions(path = null) {
        if (path) {
            this.$router.push(path);
            return;
        }
        if (CG_BASE_URL.includes(this.getOrigin)) {
            this.$router.push('/');
        }
        else {
            this.$router.push('/login/client');
        }
    }
};
WhiteLabelRedirectMixin = __decorate([
    Component({
        apollo: {
            whiteLabelContent: {
                query: WhiteLabelQuery,
                variables() {
                    return {
                        origin: this.getOrigin,
                    };
                },
                update(data) {
                    if (data.whiteLabelContent) {
                        return data.whiteLabelContent;
                    }
                    return null;
                },
            },
        },
    })
], WhiteLabelRedirectMixin);
export default WhiteLabelRedirectMixin;
